import environmentVariables from './appVariables';

export const cookieExpires = 1;

const getCookieSameSite = (): 'strict' | 'none' => {
  if (globalThis.window === undefined) {
    return 'strict';
  }
  if (globalThis.window.self === globalThis.window.top) {
    return 'strict';
  }

  return 'none';
};

export const cookieSameSite = getCookieSameSite();

export type ICookies =
  | 'token'
  | 'skillFilterId'
  | 'selectedSkill'
  | 'uidUser'
  | 'learnerProfile'
  | 'remember'
  | 'majorId'
  | 'academicProgramId'
  | 'skillForCoursesRecommendations'
  | 'recommendedOccupationsByMajor'
  | 'jobPreferencesSkillSet'
  | 'jobPreferencesSkillMatch'
  | 'jobPreferencesRelatedOccupations'
  | 'recommendedSkills'
  | 'recommendedOccupations'
  | 'kanbanData'
  | 'preferredLanguage';

export const ENVIRONMENT: string = environmentVariables?.environment ?? 'development';

export const webSocketURL =
  ENVIRONMENT === 'development' ? `${environmentVariables?.reactAppGraphqlSocketDev}/subscriptions` : `/subscriptions`;

export const publicGraphQLURL =
  ENVIRONMENT === 'development' ? `${environmentVariables?.reactAppApiGraphqlDev}/public/graphql` : `/public/graphql`;
